export enum UserStatusEnum {
    ACTIVE = 'ACTIVE',
    LOCKED = 'LOCKED',
    DISABLED = 'DISABLED',
}
